import axios from 'axios'
import { BASE_API_URL } from '../configs/api'

export const getReceipts = async () => {
    const resp = await axios.get(`${BASE_API_URL}/admin/get-receipts`)
    return resp.data
}

export const createReceiptWithData = async (data) => {
    const resp = await axios.post(`${BASE_API_URL}/admin/create-receipt`, data)
    return resp.data
}

export const deleteReceiptId = async (data) => {
    const resp = await axios.post(`${BASE_API_URL}/admin/delete-receipt`, data)
    return resp.data
}
